// extracted by mini-css-extract-plugin
export default {"component":"yiXRv","title":"AiZ8f","price":"n64SM"};